let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7CHu2")).then(() => parcelRequire('7UEtA'));